
import { getSolutionId } from '@/utils/auth'

export default {
  mounted() {
    this.solution = getSolutionId()
    if (!this.getUrlParam('state')) {
      return
    }
    this.type = this.getUrlParam('state').split('@')[1]
    this.stateCode = this.getUrlParam('state').split('@')[0]
    this.code = this.getUrlParam('code')
    console.log(this.stateCode, this.code)
    if (this.stateCode && this.code) {
      this.handleThirdPartyLogin()
    }
  },
  data() {
    return {
      type: '',
      stateCode: '',
      solution: null,
      code: null
    }
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    handleThirdPartyLogin() {
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 1)'
      })
      const info = {
        code: this.code,
        sid: this.solution,
        type: this.type,
        state: this.stateCode
      }
      this.$store.dispatch('thirdPartyLogin', info).then(() => {
        this.$store.dispatch('delAllViews')
        localStorage.removeItem('lastTab')
        window.location.href = window.location.origin
        this.$router.push('/')
        setTimeout(() => {
          loading.close()
        }, 500)
      })
        .catch(msg => {
          if (typeof msg === 'string' && msg) {
            this.$message({
              showClose: true,
              message: msg,
              type: 'error'
            })
          }
          setTimeout(() => {
            window.location.href = window.location.origin
          }, 1500)
          loading.close()
        })
    }
  }
}
